module.exports = __webpack_public_path__ + "img/works-01_ueno-wine.b14af7ae.png";